import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DiffPipe,
  ExceptPipe,
  SelectedPipe,
  KeyPipe,
  InTierPipe,
  DynamicPipe,
  ToArrayPipe,
  FilterNamePipe,
  IsDirtyPipe,
  FilterByPropertyPipe,
  UnixDatePipe,
  ListToStringPipe,
} from '@shared';

@NgModule({
  declarations: [
    ToArrayPipe,
    SelectedPipe,
    ExceptPipe,
    DiffPipe,
    KeyPipe,
    InTierPipe,
    DynamicPipe,
    FilterNamePipe,
    IsDirtyPipe,
    FilterByPropertyPipe,
    UnixDatePipe,
    ListToStringPipe,
  ],
  imports: [CommonModule],
  exports: [
    ToArrayPipe,
    SelectedPipe,
    ExceptPipe,
    DiffPipe,
    KeyPipe,
    InTierPipe,
    DynamicPipe,
    FilterNamePipe,
    IsDirtyPipe,
    FilterByPropertyPipe,
    UnixDatePipe,
    ListToStringPipe,
  ],
})
export class PipeModule {}
